import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { vat } from './Reducers/Vat.reducer';
import { articeluploaded } from './Reducers/ArticleUpload.reducer';
import { productListView } from './Reducers/ProductListView.reducer';
import { resellermaplist } from './Reducers/ResellerMapList.reducer';
import { preferedAddress } from './Reducers/PreferedAddress.reducer';
import { preferredClickCollectAddress } from './Reducers/PreferredClickCollectAddress.reducer';
import shoppingList from "./Reducers/ShoppingList.reducer";
import {saveCartView} from "./Reducers/SaveCartView.reducer";
import {chassisearch} from "./Reducers/ChassiSearch.reducer";
import{recommendedprice} from "./Reducers/RecommendedPrice.reducer";
import {clickCollectOrgs} from "./Reducers/GetClickCollectOrgs.reducer";

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    lightboxImages,
    vat,
    articeluploaded,
    productListView,
    resellermaplist,
    preferedAddress,
    preferredClickCollectAddress,
    shoppingList,
    saveCartView,
    chassisearch,
    recommendedprice,
    clickCollectOrgs
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
